import { Box, Typography, useTheme } from '@mui/material';

import CastTitle from './casting-title-component';
import { FC } from 'react';
import { pxToRem } from '@/theme/typography';

interface CastTitleWithTextProps {
  title?: string;
  text?: string;
}

export const CastTitleWithText: FC<CastTitleWithTextProps> = castTitleWithTextProps => {
  const theme = useTheme();
  return (
    <Box>
      <CastTitle title={castTitleWithTextProps.title} />
      <Typography
        component='p'
        sx={{
          fontSize: pxToRem(20),
          color: theme.palette.grey[50],
        }}
      >
        {castTitleWithTextProps.text || '-'}
      </Typography>
    </Box>
  );
};

export default CastTitleWithText;
